"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INITIATIVES_SIDEBAR_LABELS = void 0;
exports.INITIATIVES_SIDEBAR_LABELS = {
    CREATED_BY: 'Created By',
    OWNED_BY: 'Owned By',
    TAGS: 'Tags'
};
//# sourceMappingURL=INITIATIVES_SIDEBAR_LABELS.js.map